// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"bc65cf5e","443":"e8578ff2","779":"be21080a","867":"f07c7f8a"}[chunkId] + ".chunk.js";
};